import { StatsigUser } from '@statsig/react-bindings'

import { TAbsoluteLocaleStandard, TCountryStandard } from '@src/config/i18n.config'

export interface StatsigExperimentBucket {
  experimentName: string
  bucketName: string
  isActive: boolean | undefined
}

export interface StatsigServerProps {
  userId: string
  data: string
  key: string
  forcedBuckets: Record<string, string | string[]>
  serverSideExperiments: StatsigExperimentBucket[]
}

export enum StasigLoadingState {
  UNINITIALIZED = 'Uninitialized',
  LOADING = 'Loading',
  READY = 'Ready',
}

// Extend the StatsigUser type to enforce our locale format
export interface StatsigUserWithStandardLocale extends StatsigUser {
  locale: TAbsoluteLocaleStandard
  country: TCountryStandard
}
